// extracted by mini-css-extract-plugin
export default {"modalLink":"u7YIUTKaK1kkGCxZLWUQ","needRow":"_dYVyX85g1KNspwxMujL","needData":"ZroRtZG8QaLHeava9BWZ"};